import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-communication/operations/shell-protocol-namespace.const';
import {ProtocolCommand} from '../service-model/protocol-command.interface';
import {ProtocolQuery} from '../service-model/protocol-query.interface';

export class SubscribeVerticalSkew implements ProtocolCommand {
    constructor(
        public readonly underlying: string,
        public readonly expiration: string,
    ) {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.SubscribeVerticalSkew`;
    }
}

export class UnsubscribeVerticalSkew implements ProtocolCommand {
    constructor(
        public readonly underlying: string,
        public readonly expiration: string,
    ) {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.UnsubscribeVerticalSkew`;
    }
}

// One-shot reading for (underlying, expiration) — CR-20260722-002.
//
// The subscription above is right for a surface WATCHING one expiration; it cannot answer "what is
// the skew on some other date, once". The OPG Co-Pilot's override panel needs that to seed each
// date the user steps to. Doing it client-side (Subscribe, await a push, Unsubscribe) would put a
// ref-counted backend slot behind a dialog's lifetime, where a closed popup leaks option
// subscriptions for the life of the process — so the acquire/release pairing lives server-side in
// one call instead. See GetVerticalSkewQH.
//
// Either side may be null: NO USABLE READING (the scan had not converged in budget), never "flat".
export class GetVerticalSkew implements ProtocolQuery {
    constructor(
        public readonly underlying: string,
        public readonly expiration: string,
    ) {
    }

    getOperationName(): string {
        return `${SHELL_PROTOCOL_OPERATIONS_NS}.GetVerticalSkew`;
    }
}

export interface GetVerticalSkewReply {
    underlying: string;
    expiration: string;
    callSkew: number | null;
    putSkew: number | null;
}

export interface VerticalSkewChangedDto {
    underlying: string;
    expiration: string;
    callSkew: number;
    putSkew: number;
    callLoading: boolean;
    putLoading: boolean;
}
